import {
  Control,
  isSoc2ControlValid,
  isVendorAssessmentControlValid,
  Soc2Control,
  TSCABBRIVATIONS,
  VendorAssessmentControl,
  NistCsfControl,
} from "@/modules/agent/states/cusomize-controls";
import { AgentSessionType } from "@/modules/sessions/types";
import { isInValidIdForSoc2 } from "../../helpers";
import { TSCENUM } from "@/modules/agent/states/cusomize-controls";

export const getValidControlNumber = ({
  agentType,
  controls,
  selectedTab,
}: {
  agentType: AgentSessionType | null;
  controls: Control[];
  selectedTab: string | null;
}) => {
  if (
    agentType === AgentSessionType.SOC2_GAP ||
    agentType === AgentSessionType.SOC2_GAP_TYPE1 ||
    agentType === AgentSessionType.SOC2_GAP_TYPE2
  ) {
    return (controls as Soc2Control[])
      .filter((c) => isSoc2ControlValid(c) && c.tsc === selectedTab)
      .filter((c) => c.tsc_id.replaceAll(TSCABBRIVATIONS[c.tsc], "").length > 0)
      .filter(
        (c) =>
          !isInValidIdForSoc2(c.tsc_id.replaceAll(TSCABBRIVATIONS[c.tsc], ""))
      );
  }
  if (agentType === AgentSessionType.MULTI_FILE_VENDOR_ASSESSMENT) {
    return (controls as VendorAssessmentControl[]).filter(
      (c) => isVendorAssessmentControlValid(c)
    );
  }
  return controls;
};

export const filterListOfControlsBasedOnTabsAndAgentType = ({
  agentType,
  control,
  selectedTab,
}: {
  agentType: AgentSessionType | null;
  control: Control;
  selectedTab: string | null;
}) => {
  if (!selectedTab) return false;

  if (
    agentType === AgentSessionType.SOC2_GAP ||
    agentType === AgentSessionType.SOC2_GAP_TYPE1 ||
    agentType === AgentSessionType.SOC2_GAP_TYPE2
  ) {
    return (control as Soc2Control).tsc === selectedTab;
  }

  if (agentType === AgentSessionType.MULTI_FILE_VENDOR_ASSESSMENT) {
    return true
  }

  if (agentType === AgentSessionType.RISK_ASSESSMENT) {
    const nistControl = control as NistCsfControl;
    const functionText = nistControl.function?.toLowerCase() || "";
    
    // Match based on function prefix for NIST CSF controls
    if (selectedTab === "govern" && functionText.startsWith("govern")) {
      return true;
    }
    if (selectedTab === "identify" && functionText.startsWith("identify")) {
      return true;
    }
    if (selectedTab === "protect" && functionText.startsWith("protect")) {
      return true;
    }
    if (selectedTab === "detect" && functionText.startsWith("detect")) {
      return true;
    }
    if (selectedTab === "respond" && functionText.startsWith("respond")) {
      return true;
    }
    if (selectedTab === "recover" && functionText.startsWith("recover")) {
      return true;
    }
    
    return false;
  }

  return false;
};
